export default __webpack_public_path__ + "static/media/2.7495c79a.jpg";